import React, { useState } from "react";
import * as styles from "./ServiceRows.module.scss";
import { Button } from "@silversea-ssc/ui-components-react";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export interface ServiceRowsProps {
  readMore?: boolean;
  openReadMoreLabel?: string | JSX.Element;
  closeReadMoreLabel?: string | JSX.Element;
}

const ServiceRows: React.FC<ServiceRowsProps> = ({
  children,
  readMore = false,
  openReadMoreLabel,
  closeReadMoreLabel
}) => {
  const [expanded, setExpanded] = useState(false);

  return (
    <div
      className={cx({
        serviceRows: true,
        withReadMore: readMore,
        expanded: readMore && expanded
      })}
    >
      <div className={styles.rows}>{children}</div>
      {readMore && (
        <div className={styles.readMoreButtonContainer}>
          <Button
            data-content-piece="read_more_button"
            renderAs="button"
            className={styles.readMoreButton}
            variant="secondary"
            iconName={expanded ? "close" : "plus"}
            onClick={() => {
              setExpanded(!expanded);
            }}
          >
            {expanded ? closeReadMoreLabel : openReadMoreLabel}
          </Button>
        </div>
      )}
    </div>
  );
};

export default ServiceRows;
